/**
 * @module Utilities/FP
 * @desc FP helper funtions
 */

export function pipe(fns: any) {
  return (input: any) => fns.reduce((result: any, fn: any) => fn(result), input);
}
